<template>
  <div class="l-edit-dialog-box">
    <h3>接口地址</h3>
    <el-alert :title="row.url" type="info">
    </el-alert>

    <h3>请求方法</h3>
    <el-alert :title="row.func" type="info">
    </el-alert>

    <h3>请求参数</h3>

    <div style="background:#f4f4f5;color:#909399;padding: 8px 16px;border-radius:5px">
      <!-- <vue-json-pretty :data="JSON.parse(row.params)" :path="'res'">
      </vue-json-pretty> -->
    </div>

    <template v-if="row.err_msg">
      <h3>错误信息</h3>
      <el-alert :title="row.err_msg" type="error">
      </el-alert>
    </template>

    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>

  </div>
</template>

<script>
// import VueJsonPretty from "vue-json-pretty";
// import "vue-json-pretty/lib/styles.css";
export default {
  name: "l-logs-info",
  // components: {
  //   VueJsonPretty,
  // },
  props: {
    row: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
    },
    
  },
  computed: {},
  data() {
    return {

    };
  },

  watch: {
    visible: {
      immediate: true,
      handler() {},
    },
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    
  },
};
</script>

<style lang="scss" scope>
.l-edit-dialog-box {
  // background: #f5f7f9;
}

.l-order-title {
  font-size: 17px;
  font-weight: bold;
}

.l-order-line {
  background-color: rgb(233, 233, 235);
  height: 2px;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}

.l-order-line-1 {
  background-color: rgb(233, 233, 235);
  height: 1px;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 20px;
}

.jt-order-detail-container {
  margin-top: 20px;
}

.jt-order-detail-item {
  display: flex;
  font-size: 15px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .text {
    font-weight: bold;
  }
}

.l-order-delivery-detail-container {
  display: flex;
  margin-top: 20px;
}

.l-order-delivery-detail-item {
  padding: 12px 12px;
  padding-bottom: 20px;
  padding-right: 25px;
  border-radius: 7px;
  position: relative;
  background: #fff;
  flex: 1;
  display: flex;
  box-shadow: 0px 0 6px #ddd;
  &:first-child {
    margin-right: 15px;
  }
  &:last-child {
    margin-left: 15px;
  }

  .l-order-delivery-icon {
    img {
      width: 30px;
    }
  }

  .l-order-delivery-detail-content {
    margin-left: 8px;
    .l-sr-name {
      font-weight: bold;
      padding-top: 3px;

      .l-primary {
        font-size: 13px;
      }

      .l-normal {
        font-size: 13px;
      }
    }
  }

  .l-address-container {
    margin-top: 3px;
    font-size: 13px;

    .l-detail-address {
      margin-top: 4px;
    }
  }

  .l-order-delivery-right-icon {
    position: absolute;
    right: 10px;
    top: 5px;
    width: 18px;
    img {
      width: 100%;
    }
  }
}

.l-order-track-box {
  margin-top: 45px;

  .l-order-detail-track-date {
    font-weight: bold;
    margin-bottom: 30px;
  }

  .l-order-track-flex {
    display: flex;
  }
}

.l-order-dot {
  height: 20px;
  width: 20px;
  margin-top: -5px;
  img {
    margin-left: -5px;

    width: 20px;
  }
}
.l-order-v-line {
  background: $success-color;
  margin-right: 9px;
  margin-bottom: px;
  margin-top: 3px;
  width: 3px;
}

.l-order-detail-driver-name {
  font-weight: bold;
}

::v-deep .el-timeline-item {
  padding-bottom: 12px !important;
}
</style>